<template>
  <div class="box-style">
    <van-nav-bar placeholder title="意见详情" left-text="" left-arrow @click-left="onClickLeft()">
      <template #right>
      </template>
    </van-nav-bar>
    <van-pull-refresh v-model="loading" @refresh="refresh()" style="min-height: calc(100vh - 45px);">
      <div class="yj-box">
        <div class="box-title" @click="ideaShow = !ideaShow">
          <h2>意见内容</h2>
          <img src="@/assets/xl.png" v-if="ideaShow">
          <img src="@/assets/sl.png" v-else>
        </div>
        <div class="yj-con" v-show="ideaShow">
          <div class="con-list"><span>提交时间：</span><p>{{record.ideaTime}}</p></div>
          <div class="con-list"><span>意见类型：</span><p>{{getDictName(ideaTypeOptions, record.ideaType)}}</p></div>
          <div class="con-list"><span>意见内容：</span><p>{{record.ideaDes}}</p></div>
          <div class="con-list"><span>图片：</span><p><custom-upload :value="record.ideaUrls" :showUpload="false"/></p></div>
        </div>
      </div>
      <div  class="yj-box" v-if="record.replyUserId">
        <div  class="box-title" @click="replyShow = !replyShow">
          <h2>意见回复</h2>
          <img src="@/assets/xl.png" v-if="replyShow">
          <img src="@/assets/sl.png" v-else>
        </div>
        <div class="yj-con" v-show="replyShow">
          <div class="con-list"><span>回复内容：</span><p>{{record.replyDes}}</p></div>
          <div class="con-list"><span>图片：</span><p><custom-upload :value="record.replyUrls" :showUpload="false"/></p></div>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
  import customUpload from '@/components/customUpload'
  import {getDictByType} from '@/api/common'
  import {getDictName} from '@/utils/common'
  import {get} from '@/api/my/idea'
  export default {
    name: 'ideaDetail',
    components: {
      // eslint-disable-next-line vue/no-unused-components
      customUpload
    },
    data() {
      return {
        ideaShow: true,
        replyShow: true,
        getDictName,
        id: '',
        loading: false,
        record: {},
        ideaTypeOptions: [],
      }
    },
    created() {
      this.id = this.$route.query.id
      this.getDict()
      this.refresh()
    },
    mounted() {
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1)
      },
      refresh() {
        this.getDetail()
      },
      getDetail() {
        get(this.id).then(res => {
          if (res.code === 10000) {
            this.record = res.result
          }
        }).finally(() => {
          setTimeout(() => {
            this.loading = false
          }, 100)
        })
      },
      getDict() {
        // 查询字典，意见类型
        getDictByType('idea_type').then(res => {
          if (res.code === 10000) {
            this.ideaTypeOptions = res.result.map(item => {
              return {label: item.dictKey, value: item.dictValue}
            })
          }
        });
      },
    }
  }
</script>

<style scoped>
.yj-box{
  display: flex;
  margin: 0 10px;
  flex-direction: column;
}
.box-title{
  display: flex;
  align-items: center;
  justify-content: space-between;
  height:16px;
  margin-top: 23px;
  margin-bottom: 17px;
}
.box-title h2{
  display: flex;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
}
.box-title img{
  width: 16px;
  height: 9px;
}
.yj-con{
  background: #F4F5F7;
  border-radius:12px;
  display: flex;
  padding: 17px;
  flex-direction: column;
}
.con-list{
  display: flex;
  margin-bottom: 15px;
}
.con-list:last-child{
  margin-bottom: 0;
}
.con-list span{
  display: flex;
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #777777;
  width:75px;
  justify-content: flex-end;
  padding-right: 5px;
}
.con-list p{
  display: flex;
  flex: 1;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
/deep/.van-uploader__preview-image{
  height: 15vw;
  width:73px;
}
.box-style{
  padding-bottom: 20px;
}
</style>
